'use client'

import { useEffect } from 'react'
import * as Sentry from '@sentry/react'
import { useUser } from '../api/auth'

export default function SentryUserSync() {
  const { user } = useUser()

  useEffect(() => {
    if (user) {
      Sentry.setUser({
        id: user?.id
      })
    } else {
      Sentry.setUser(null)
    }
  }, [user])

  return null
}
